import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Module, Right} from '../../models/models';
import {Translation} from '../../models/translation';
import {LoginService} from '../../services/login.service';
import {CheckService} from '../../services/check.service';

@Component({
  selector: 'app-transport',
  styleUrls: ['./transport.component.css'],
  templateUrl: './transport.component.html',
})
export class TransportComponent implements OnInit {

  public translation: Translation;
  public transportTaskModule: Module;
  public damageReportModule: Module;
  public homeDeliveryTaskModule: Module;
  public damageCaseModule: Module;
  public rights: Right[];

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private router: Router,
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkModule(10);
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.rights = JSON.parse(sessionStorage.getItem('Rights'));
    this.rights.forEach(right => {
      switch (right.RightId) {
        case 4:
          this.transportTaskModule = new Module();
          this.transportTaskModule.ModuleName = this.translation.TransportTaskCardTitle;
          this.transportTaskModule.ModuleDesc = this.translation.TransportTaskCardDesc;
          this.transportTaskModule.ModuleButtonText = this.translation.TransportTaskCardAction;
          this.transportTaskModule.ForwardLink = '/transport-task';
          break;
        case 5:
          this.damageReportModule = new Module();
          this.damageReportModule.ModuleName = this.translation.DamageReportCardTitle;
          this.damageReportModule.ModuleDesc = this.translation.DamageReportCardDesc;
          this.damageReportModule.ModuleButtonText = this.translation.DamageReportCardAction;
          this.damageReportModule.ForwardLink = '/damagereport';
          this.damageCaseModule = new Module();
          this.damageCaseModule.ModuleName = this.translation.DamageReportCardTitle + ' (Neu)';
          this.damageCaseModule.ModuleDesc = this.translation.DamageReportCardDesc;
          this.damageCaseModule.ModuleButtonText = this.translation.DamageReportCardAction;
          this.damageCaseModule.ForwardLink = '/damage-case';
          break;
        case 25:
          this.homeDeliveryTaskModule = new Module();
          this.homeDeliveryTaskModule.ModuleName = this.translation.HomeDeliveryCardTitle;
          this.homeDeliveryTaskModule.ModuleDesc = this.translation.HomeDeliveryCardDesc;
          this.homeDeliveryTaskModule.ModuleButtonText = this.translation.HomeDeliveryCardAction;
          this.homeDeliveryTaskModule.ForwardLink = '/homedelivery';
          break;
      }
    });
  }

  navigate(forwardLink: string) {
    this.router.navigate([forwardLink]);
  }
}
